import { graphAxisLines } from './';
export const graphOverviewAxis = (theme, parameters) => {
  const axisLines = graphAxisLines(theme, parameters);
  return {
    lineColor: axisLines.lineColor,
    lineThickness: axisLines.lineThickness
  };
};
//# sourceMappingURL=graphOverviewAxis.js.map